import { Component, computed, effect, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { EvTimePeriodFilterComponent, ILocalTimePeriodFilter, IRangeToMonth } from "ev-time-period-filter";
import { Subject } from "rxjs";
import { TimePeriodFilterModel } from "./search-filter-time-period.model";

@Component({
    selector: "search-filter-time-period",
    imports: [EvTimePeriodFilterComponent],
    templateUrl: "./search-filter-time-period.component.html",
    styleUrl: "./search-filter-time-period.component.scss",
})
export class SearchFilterTimePeriodComponent {
    filterForm = input.required<FieldTree<TimePeriodFilterModel>>();
    readonly rangeToMonthListValue = input<IRangeToMonth[]>();
    
    defaultValue: ILocalTimePeriodFilter = {
         toDate: null,
        fromDate: null,
        useFromToDate: false,
        numberOfMonthsToShow: 12,
        minSelectableFromDate: new Date(1990,1,1)
    };
    selectedValue: ILocalTimePeriodFilter = {
         toDate: null,
        fromDate: null,
        useFromToDate: false,
        numberOfMonthsToShow: 12
    };
    
    validationErrors = computed<string[]>(() => {
        const timePeriod = this.filterForm();
        const messages = [...timePeriod.fromDate().errors(), ...timePeriod.toDate().errors()]
            .map((error) => (error as { message?: string }).message)
            .filter((message): message is string => !!message);

        return [...new Set(messages)];
    });

    constructor() {
        effect(() => {
            this.selectedValue = {
                toDate: this.filterForm().toDate().value(),
                fromDate: this.filterForm().fromDate().value(),
                useFromToDate: this.filterForm().useFromToDate().value(),
                numberOfMonthsToShow: this.filterForm().numberOfMonthsToShow().value(),
            };
        });
    }

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }

    onChange(event: any) {
        if (event.numberOfMonthsToShow != null) {
            this.filterForm().useFromToDate().value.set(false);
            this.filterForm().numberOfMonthsToShow().value.set(event.numberOfMonthsToShow);
            this.filterForm().fromDate().value.set(null);
            this.filterForm().toDate().value.set(null);
        } else {
            this.filterForm().useFromToDate().value.set(true);
            this.filterForm().toDate().value.set(event.toDate);
            this.filterForm().fromDate().value.set(event.fromDate);
        }
    }
}
